import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";
import "@mantine/core/styles.css";

import { App } from "@/app";
import { AuthProvider } from "@/auth/auth-provider";
import { LocaleProvider } from "@/i18n/locale-provider";
import { createQueryClient } from "@/lib/query-client";
import { AppThemeProvider } from "@/theme/app-theme-provider";

import "./index.css";

const container = document.getElementById("root");

if (!container) {
  throw new Error("The #root element is missing from index.html.");
}

const queryClient = createQueryClient();

createRoot(container).render(
  <StrictMode>
    {/* The query client sits above AuthProvider because ending a session
        clears the cache, so the provider needs access to it. */}
    <QueryClientProvider client={queryClient}>
      <LocaleProvider>
        <AppThemeProvider>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </AppThemeProvider>
      </LocaleProvider>
    </QueryClientProvider>
  </StrictMode>,
);
